import React from 'react';
import PropTypes from 'prop-types';

import {Http, Credential, unwrapDynamic, capitalizeFirst} from 'common';

export class AuthPage extends React.Component {
    static contextTypes = {
        environment: PropTypes.object,
        messenger: PropTypes.object,
        router: PropTypes.object
    }

    onSubmit = (data, resetForm) => {
        const {url, method, sanitize, redirect, failure, keepValues} = this.config

        const requestUrl = unwrapDynamic(url, data)
        const requestMethod = unwrapDynamic(method, data)||'post'

        let requestData = {...data}

        if (sanitize != null)
            requestData = sanitize(requestData)

        this.setState({loading: true})

        Http.CALL(requestUrl, requestData, requestMethod, (resp, status) => {
            this.setState({loading: false})
            this.onResponse(data, resp, status)

            if (this.onAfterSubmit != null) {
                this.onAfterSubmit(data, resp)
            }

            Http.invalidateToken()

            if (status == null && redirect != null) {
                const {router} = this.context
                const route = unwrapDynamic(redirect, data)

                if (route) {
                    router.history.push(route)
                } else if (keepValues !== true) {
                    resetForm()
                }

                this.setState({
                    complete: true,
                    sentData: requestData
                })
            }

            if (status && failure) {
                const {router} = this.context
                const route = unwrapDynamic(failure, resp.type)

                if (route) {
                    router.history.push(route)
                }
            }

        })
    }

    onRepeat = () => {
        const {complete, sentData} = this.state || {}
        if (!complete) { return }

        const {repeat} = this.config
        const repeatUrl = unwrapDynamic(repeat, sentData)
        Http.POST(repeatUrl, sentData, (resp, status) => {
            this.onResponse(sentData, resp, status)
            Http.invalidateToken()
        })
    }

    onResponse = (data, resp, status) => {
        const {sentData} = this.state || {}
        const {namespace, typeOf, finalize} = this.config
        const {messenger} = this.context

        const messageNamespace = capitalizeFirst(unwrapDynamic(namespace, data))
        const messageType = capitalizeFirst(unwrapDynamic(typeOf, data)||'')

        const messageCode = (status == null) ? 'Success' : resp.type
        messenger.publish(messageCode, messageNamespace, messageType)

        if (status == null) {
            finalize && finalize(sentData)
        }
    }

}
